import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, DatePickerField, EditFormContent, BaasicButton, BasicInput, BasicFieldCheckbox, BasicTextArea} from 'core/components';

function PumpFullEditTemplate({ editView }) {
    const {
        form,
        statusStore,
        pumpStore
    } = editView;

    return (
        <React.Fragment>
            <div className="modal__header">
                <h3 className='modal__header__title'>Edit</h3>
            </div>
            <EditFormContent form={form}>
                <div className="modal__body">
                    <div className="row">
                        <div className="form__group col col-lrg-6">
                            <BaasicFieldDropdown field={form.$('productId')} store={pumpStore} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('serialNumber')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BaasicFieldDropdown field={form.$('pumpStatusId')} store={statusStore} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <DatePickerField field={form.$('dateSent')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <DatePickerField field={form.$('dateReturnRequested')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <DatePickerField field={form.$('dateReturned')} />
                        </div>
                        <div className="form__group col col-lrg-6 u-flex--align-center">
                            <BasicFieldCheckbox field={form.$('stickered')}/>Sticker
                        </div>
                        <div className="form__group col col-lrg-6 u-flex--align-center u-flex--gap--2">
                            <span>Branch</span>
                            <div className='btn--toggled__wrap' style={{ display: 'inline-flex' }}>
                                {[{ value: 'Lakewood', label: 'Lkwd' }, { value: 'Chicago', label: 'Chi' }].map((option) => (
                                    <button
                                        key={option.value}
                                        type="button"
                                        className={`btn btn--toggled ${form.$('branch').value === option.value ? 'btn--primary' : ''}`}
                                        onClick={() => form.$('branch').set(option.value)}
                                    >
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="form__group col col-lrg-12">
                            <BasicTextArea field={form.$('notes')} />
                        </div>
                    </div>
                </div>
                <div className="modal__footer">
                    <BaasicButton
                        type='submit'
                        className='btn btn--med btn--primary'
                        label="Submit"
                        rotate
                        icon={
                            form.submitting || form.validating
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                        onClick={form.onSubmit}
                        disabled={form.submitting || form.validating}
                    />
                </div>
            </EditFormContent>
        </React.Fragment>
    )
}

PumpFullEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PumpFullEditTemplate);
